import {ACTION_CODE} from './_actionCode';
import {ServicesService} from '../../services';
import {ErrorModel, ResultModel} from '../../models';
import {LoggerService} from '../../services';

const FUNCTION_CODE = 'DELETE_SERVICE';

export async function deleteService(token = '', projectId: number | string) {
    try {
        LoggerService.logInfo('Action - deleteService - Start');

        const result = await ServicesService.deleteService(token, projectId);

        LoggerService.logInfo('Action - deleteService - End - Success');

        return ResultModel.newSuccessResult(result);
    }
    catch (error) {
        LoggerService.logInfo('Action - deleteService - End - Error');

        const newErr = ErrorModel.newError({
            code: `${ACTION_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue lors de la suppression du service',
            error: error
        });

        LoggerService.logError(error);

        return ResultModel.newErrorResult(newErr);
    }
}
